// @ts-check
import classNames from 'classnames';
import React from 'react';
import ActionColumns from '~/components/Modules/ActionColumns';
import CopyBlock from './CopyBlock';

import './ColumnBlock.scss';

/**
 * Adjacent Columns sections will be stacked into one.
 * @typedef ModularBlockColumns
 * @property {string} [uid]
 * @property {boolean} [align_center=false]
 * @property {'none' | 'numbered' | 'lettered'} [column_numbering='none']
 * @property {import('./CopyBlock').MainContentOptions[]} content
 * 
 * @typedef ColumnBlockProps 
 * @property {import('./CopyBlock').ModularBlockCopyContent[]} options

 */
/** @type {import('~/types/React').ReactFC<ColumnBlockProps>} */
const ColumnBlock = ({options}) => {
	if (!options?.length) {
		return null;
	}

	return (
		<ActionColumns
			alignCenter={options?.[0]?.text_align === 'center'}
			isContainer={options?.[0]?.column_option.toString() !== 'dense'}
		>
			{options.map((opt, i) => (
				<SingleColumn content={opt} index={i} key={i} />
			))}
		</ActionColumns>
	);
};

/**
 * @typedef SingleColumnProps
 * @property {import('./CopyBlock').ModularBlockCopyContent} content
 * @property {number} index
 */
/** @type {import('~/types/React').ReactFC<SingleColumnProps>} */
const SingleColumn = ({ className, content, index }) => {
	const heading = GetColNumber(content.column_option, index);
	const isCard = content.column_option === 'gray-card';

	const coreContent = (
		<>
			{heading && <h1 className="column-numbering">{heading}</h1>}

			{/* <CopyBlock options={{ copy: { copy: column.content } }} /> */}
			<CopyBlock options={{ copy: content }} />
		</>
	);

	return (
		<div className={classNames(className, 'single-column', content.column_option)}>
			{isCard ? <div className="single-column-gray-card">{coreContent}</div> : coreContent}
		</div>
	);
};

/**
 *
 * @param {import('./CopyBlock').ModularBlockColumnHeadingOption} columnOption The option to write.
 * @param {number} i The index of this column.
 * @returns {string | null} The heading content.
 */
function GetColNumber(columnOption, i) {
	switch (columnOption) {
		case 'letter':
			return ['A', 'B', 'C', 'D'][i];
		case 'number':
			return `${i + 1}`;
		case 'hidden':
		case 'none':
		default:
			return null;
	}
}

export default ColumnBlock;

